import owd from 'owd/owd';

export default class Modal extends owd.Component {
	init() {
        this.closeButton = this.$element.find('.modal-close');

		this.bind();
    }
    
    show() {
        this.$element.removeClass('is-hidden');
        if (this.$element.is('[data-modal-info]') || this.$element.is('[data-newsletter]')) {
            this.dom.$html.addClass('scroll-is-blocked');
        }
    }

    hide() {
        this.$element.addClass('is-hidden');
        if (this.$element.is('[data-modal-info]') || this.$element.is('[data-newsletter]')) {
            this.dom.$html.removeClass('scroll-is-blocked');
        }
    }

	bind() {
        this.on('click', this.closeButton, this.hide.bind(this));
        this.on('hide', this.$element, this.hide.bind(this));
        this.on('show', this.$element, this.show.bind(this));
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('modal', {
	component: Modal
});
